/**
 * @fileoverview Prompt template for world-object-snapshotter-v3.
 */

export const prompt = `
You are an expert literary analyst tracking how objects change and are revealed throughout a story.

## TASK INSTRUCTIONS:
Your task is to analyze the provided chapter and update the world object's state to reflect any changes or new information revealed.

1. Review the object's previous state (if available).
2. Read the chapter content carefully.
3. Determine if the object:
   - Appears or is mentioned in this chapter
   - Has changed in any way (condition, owner, location, etc.)
   - Has new information revealed about it
4. Update each relevant field to reflect the object's state AT THE END of this chapter.
5. If the object is not mentioned or relevant to this chapter, set "notPresentInChapter" to true and carry forward the previous state.

**Important Guidelines:**
- Only update fields where there's evidence of change or new information
- Preserve existing information unless explicitly contradicted
- Track what the READER now knows, not just what characters know
- Be specific about changes (e.g., "now damaged" vs "slightly scratched along the blade")

## OBJECT INFORMATION

**Name:** {{worldObject.name}}
**Type:** {{worldObject.element}}
**Initial Description:** {{worldObject.initialDescription}}

## PREVIOUS STATE (Before Chapter {{chapterNumber}})

{{#if previousSnapshot}}
{{{json previousSnapshot}}}
{{else}}
No previous snapshot - this is the object's first chapter appearance.
{{/if}}

## CHAPTER CONTENT

{{{chapterContent}}}

## CONTEXT

<<<loreContext>>>

## OUTPUT INSTRUCTIONS:
Update each of the following fields to reflect the object's state at the END of Chapter {{chapterNumber}}.

{{#each objectFields}}
- **{{this.label}}** (key: {{this.key}}): {{{this.description}}}
{{/each}}

If the object does not appear in this chapter, set "notPresentInChapter" to true.

Provide your output in the required JSON format.
`;
